import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';
import Select from '../../common/components/Select';

export default class PuzzleDebunkerModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs = vnode.attrs;
    this.puzzleList = this.attrs.puzzleList || [];
    this.currentPage = 1; // 新增分页状态
    this.hasMore = true; // 是否还有更多数据
    this.isLoading = false; // 加载状态
  }

  className() {
    return 'Modal--small dl-modal-small puzzle-debunker-modal';
  }

  title() {
    return;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (!this.attrs.trigger) {
      this.scrollContainer = document.getElementById('puzzle-debunker-list');
      // if (this.scrollContainer) {
      //   this.scrollContainer.addEventListener('scroll', this.handleScroll.bind(this));
      // }
    }
  }

  onremove() {
    // if (this.scrollContainer && !this.attrs.trigger) {
    //   this.scrollContainer.removeEventListener('scroll', this.handleScroll);
    // }
  }
  content() {
    return (
      <div className="puzzle-debunker-box">
        {this.attrs.index === 6 && this.attrs.trigger && (
          <div className="puzzle-debunker-list">
            <p>Arctic</p>
            <p>Lyric</p>
            <p>Writing</p>
            <p>Echo</p>
            <p>Skirt</p>
            <p>∞</p>
            <p>Energy</p>
            <p>Lemon</p>
            <p>Empty</p>
            <p>Avid</p>
            <p>Weather</p>
            <p>Nature</p>
          </div>
        )}
        {!this.attrs.trigger && (
          <div>
            <div className="puzzle-debunker-header">
              <div className="puzzle-debunker-title">{app.translator.trans('dl_setGuessGame.forum.PuzzleDebunkerModal.early_bird')}</div>
              {this.puzzleList.length > 0 ? (
                <p>
                  Server:{this.puzzleList[0].attributes.srvId} {this.puzzleList[0].attributes.roleName}
                </p>
              ) : (
                <p>{app.translator.trans('dl_setGuessGame.forum.PuzzleDebunkerModal.not_bird')}</p>
              )}
            </div>
            <div id="puzzle-debunker-list" className="puzzle-debunker-list">
              {this.puzzleList &&
                this.puzzleList.slice(1).map((item, index) => (
                  <p key={index}>
                    Server:{item.attributes.srvId} {item.attributes.roleName}
                  </p>
                ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  handleScroll() {
    if (!this.scrollContainer) return;
    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer;
    const threshold = 50; // 距离底部50px触发

    if (scrollHeight - (scrollTop + clientHeight) < threshold) {
      this.loadMore();
    }
  }
  loadMore() {
    if (!this.hasMore || this.isLoading) return;
    this.isLoading = true;
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/guessGame/' + this.attrs.index,
        params: {
          page: {
            limit: 50,
            offset: this.currentPage * 20,
          },
        },
      })
      .then((res) => {
        if (res.data.length) {
          this.puzzleList = [...this.puzzleList, ...res.data];
          this.currentPage++;
          m.redraw();
        } else {
          this.hasMore = false;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
